export const ceilToNext = (value: number, next = 1_000) => Math.ceil(value / next) * next;
